'use strict';

module.exports = 'enhanceArray';


//////////////////
// WEBPACK FOOTER
// ./~/sugar/enumerable/var/ARRAY_ENHANCEMENTS_FLAG.js
// module id = 53
// module chunks = 0